// src/components/Logout.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear both the token and userRole from localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('userRole'); // Also clear the user role
    // Redirect to the login page or landing page
    navigate('/login', { replace: true });
  }, [navigate]);

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <p className="text-gray-700 text-lg">Logging out...</p>
    </div>
  );
};

export default Logout;